import TemplateView from "../../TemplateView";

export default class Checkbox extends TemplateView {
    constructor({
        boxClasses,
        onClickCb = () => {}
    }) {
        super(null)

        this.params = {
            boxClasses
        }

        this.state = {
            checked: false
        }

        this.onClickCb = onClickCb

        this.onStatePropertyChanged('checked', () => {
            this.getEl().toggleClass('checked', this.state.checked)
        })
    }

    templateHtml(){
        return '<div class="checkbox <%-boxClasses%>"/>'
    }

    templateModel(){
        return {
            boxClasses: this.params.boxClasses
        }
    }

    afterRender(){
        this.getEl().on("click", () => {
            this.setState({checked: true})
            this.onClickCb()
        });
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/workflowSettings/Checkbox.js